import type { Instrument } from "../data/instruments";
import { useI18n } from "../i18n/LocaleContext";

interface VariantSelectorProps {
  instrument: Instrument;
  value: string;
  onChange: (variantId: string) => void;
}

export function VariantSelector({ instrument, value, onChange }: VariantSelectorProps) {
  const { t } = useI18n();

  return (
    <label className="control-field">
      <span>{t.controls.variant}</span>
      <select
        aria-label="Select instrument variant"
        data-testid="variant-select"
        value={value}
        onChange={(event) => onChange(event.currentTarget.value)}
      >
        {instrument.variants.map((variant) => (
          <option key={variant.id} value={variant.id}>
            {variant.name}
          </option>
        ))}
      </select>
    </label>
  );
}
